import { Live2DFramework } from "./Live2DFramework";

export class ModelSettingJson {
  NAME = "name";
  ID = "id";
  MODEL = "model";
  TEXTURES = "textures";
  HIT_AREAS = "hit_areas";
  PHYSICS = "physics";
  POSE = "pose";
  EXPRESSIONS = "expressions";
  MOTION_GROUPS = "motions";
  SOUND = "sound";
  FADE_IN = "fade_in";
  FADE_OUT = "fade_out";
  LAYOUT = "layout";
  INIT_PARAM = "init_param";
  INIT_PARTS_VISIBLE = "init_parts_visible";
  VALUE = "val";
  FILE = "file";

  json = {};

  loadModelSetting = function (path, callback) {
    var thisRef = this;
    var pm = Live2DFramework.getPlatformManager();
    pm.loadBytes(path, function (buf) {
      var str = String.fromCharCode.apply(null, new Uint8Array(buf));
      thisRef.json = JSON.parse(str);
      callback();
    });
  };

  getTextureFile = function (n) {
    if (this.json[this.TEXTURES] == null || this.json[this.TEXTURES][n] == null) return null;

    return this.json[this.TEXTURES][n];
  };

  getModelFile = function () {
    return this.json[this.MODEL];
  };

  getTextureNum = function () {
    if (this.json[this.TEXTURES] == null) return 0;

    return this.json[this.TEXTURES].length;
  };

  getHitAreaNum = function () {
    if (this.json[this.HIT_AREAS] == null) return 0;

    return this.json[this.HIT_AREAS].length;
  };

  getHitAreaID = function (n) {
    if (this.json[this.HIT_AREAS] == null || this.json[this.HIT_AREAS][n] == null) return null;

    return this.json[this.HIT_AREAS][n][this.ID];
  };

  getHitAreaName = function (n) {
    if (this.json[this.HIT_AREAS] == null || this.json[this.HIT_AREAS][n] == null) return null;

    return this.json[this.HIT_AREAS][n][this.NAME];
  };

  getPhysicsFile = function () {
    return this.json[this.PHYSICS];
  };

  getPoseFile = function () {
    return this.json[this.POSE];
  };

  getExpressionNum = function () {
    return this.json[this.EXPRESSIONS] == null ? 0 : this.json[this.EXPRESSIONS].length;
  };

  getExpressionFile = function (n) {
    if (this.json[this.EXPRESSIONS] == null) return null;
    return this.json[this.EXPRESSIONS][n][this.FILE];
  };

  getExpressionName = function (n) {
    if (this.json[this.EXPRESSIONS] == null) return null;
    return this.json[this.EXPRESSIONS][n][this.NAME];
  };

  getLayout = function () {
    return this.json[this.LAYOUT];
  };

  getInitParamNum = function () {
    return this.json[this.INIT_PARAM] == null ? 0 : this.json[this.INIT_PARAM].length;
  };

  getMotionNum = function (name) {
    if (this.json[this.MOTION_GROUPS] == null || this.json[this.MOTION_GROUPS][name] == null) return 0;

    return this.json[this.MOTION_GROUPS][name].length;
  };

  getMotionFile = function (name, n) {
    if (
      this.json[this.MOTION_GROUPS] == null ||
      this.json[this.MOTION_GROUPS][name] == null ||
      this.json[this.MOTION_GROUPS][name][n] == null
    )
      return null;

    return this.json[this.MOTION_GROUPS][name][n][this.FILE];
  };

  getMotionSound = function (name, n) {
    if (
      this.json[this.MOTION_GROUPS] == null ||
      this.json[this.MOTION_GROUPS][name] == null ||
      this.json[this.MOTION_GROUPS][name][n] == null ||
      this.json[this.MOTION_GROUPS][name][n][this.SOUND] == null
    )
      return null;

    return this.json[this.MOTION_GROUPS][name][n][this.SOUND];
  };

  getMotionFadeIn = function (name, n) {
    if (
      this.json[this.MOTION_GROUPS] == null ||
      this.json[this.MOTION_GROUPS][name] == null ||
      this.json[this.MOTION_GROUPS][name][n] == null ||
      this.json[this.MOTION_GROUPS][name][n][this.FADE_IN] == null
    )
      return 1000;

    return this.json[this.MOTION_GROUPS][name][n][this.FADE_IN];
  };

  getMotionFadeOut = function (name, n) {
    if (
      this.json[this.MOTION_GROUPS] == null ||
      this.json[this.MOTION_GROUPS][name] == null ||
      this.json[this.MOTION_GROUPS][name][n] == null ||
      this.json[this.MOTION_GROUPS][name][n][this.FADE_OUT] == null
    )
      return 1000;

    return this.json[this.MOTION_GROUPS][name][n][this.FADE_OUT];
  };

  getInitParamID = function (n) {
    if (this.json[this.INIT_PARAM] == null || this.json[this.INIT_PARAM][n] == null) return null;

    return this.json[this.INIT_PARAM][n][this.ID];
  };

  getInitParamValue = function (n) {
    if (this.json[this.INIT_PARAM] == null || this.json[this.INIT_PARAM][n] == null) return NaN;

    return this.json[this.INIT_PARAM][n][this.VALUE];
  };

  getInitPartsVisibleNum = function () {
    return this.json[this.INIT_PARTS_VISIBLE] == null ? 0 : this.json[this.INIT_PARTS_VISIBLE].length;
  };

  getInitPartsVisibleID = function (n) {
    if (this.json[this.INIT_PARTS_VISIBLE] == null || this.json[this.INIT_PARTS_VISIBLE][n] == null) return null;
    return this.json[this.INIT_PARTS_VISIBLE][n][this.ID];
  };

  getInitPartsVisibleValue = function (n) {
    if (this.json[this.INIT_PARTS_VISIBLE] == null || this.json[this.INIT_PARTS_VISIBLE][n] == null) return NaN;

    return this.json[this.INIT_PARTS_VISIBLE][n][this.VALUE];
  };
}
